export const firebaseConfig = {
  apiKey: 'AIzaSyA9wmE3OWJGTlrCtxwyUPhScYimGJPHBgk',
  authDomain: 'rare-guide-352002.firebaseapp.com',
  projectId: 'rare-guide-352002',
  storageBucket: 'rare-guide-352002.appspot.com',
  messagingSenderId: '416899977795',
  appId: '1:416899977795:web:a094257b4f6aafc89b3af6',
  measurementId: 'G-MMRVV5FL6G'
};
